const getTodayDate = () => {
  const now = new Date();
  const dd = String(now.getDate()).padStart(2, "0");
  const mm = String(now.getMonth() + 1).padStart(2, "0"); //January is 0!
  const yyyy = now.getFullYear();
  const todayDate = `${yyyy}-${mm}-${dd}`;
  return todayDate;
};
export default getTodayDate;
